import React from 'react';

import { type CommonActionBaseProps, type CommonActionButtonProps } from '@pkg/primitives';

import { type DataChipSuffixType } from './types';

import { DataChipButton, DataChipStatic, EmptyState, Label, Suffix, Value } from './styles';

export interface DataChipProps {
    label?: string | number;
    value?: string | number;
    suffix?: string | number;
    suffixType?: DataChipSuffixType;
    // Consider supporting `Link` props.
    ariaLabel?: CommonActionButtonProps['ariaLabel'];
    disabled?: CommonActionBaseProps['disabled'];
    pressed?: CommonActionBaseProps['pressed'];
    onAction?: CommonActionButtonProps['onAction'];
}

export function DataChip({
    label,
    value,
    suffix,
    suffixType = 'neutral',
    ariaLabel,
    disabled = false,
    pressed = false,
    onAction,
}: DataChipProps) {
    const labelMarkup = label ? <Label>{label}</Label> : null;
    const valueMarkup = value ? <Value>{value}</Value> : null;
    const suffixMarkup = suffix ? <Suffix $type={suffixType}>{suffix}</Suffix> : null;

    const hasContent = Boolean(labelMarkup || valueMarkup || suffixMarkup);

    const children = (
        <>
            {labelMarkup}
            {valueMarkup}
            {suffixMarkup}

            {hasContent ? null : <EmptyState>&hellip;</EmptyState>}
        </>
    );

    return onAction ? (
        <DataChipButton ariaLabel={ariaLabel} disabled={disabled} pressed={pressed} onAction={onAction}>
            {children}
        </DataChipButton>
    ) : (
        <DataChipStatic>{children}</DataChipStatic>
    );
}
